import React from "react";
import { TypeOf } from 'zod';
import {Save} from "@mui/icons-material";
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import {Button, Stack, Box, Badge,} from "@mui/material";
import useEntity from "../../../hooks/useShipmentHistory";
import {PrimaryShipmentHistory} from "../../../types/models/ShipmentHistory";
import {useGetShipmentHistoryQuery} from "../../../apis/ShipmentHistory.api";
import ShipmentHistoryUpdateForm, {formSchema, initialFormStateFn} from "../../../components/shipmentHistory/ShipmentHistoryForm/ShipmentHistoryUpdateForm";
import { Trans } from "@lingui/react/macro";

export type FormInput = TypeOf<typeof formSchema>;

const ShipmentHistoryUpdateFormProvider = ({ id, initialFormState, cancelButton = undefined, redirectPath = undefined, successAction = undefined }) => {

    const primary = PrimaryShipmentHistory.fromPath(id);
    const { data, isLoading } = useGetShipmentHistoryQuery(primary)

    const methods = useForm<FormInput>({
        resolver: zodResolver(formSchema),
        defaultValues: initialFormState(data)
    });
    const {  } = useEntity();

    const {
        watch,
        reset,
        handleSubmit,
        formState: { isSubmitSuccessful, errors, },
    } = methods;

    React.useEffect(() => {
        if (data) {
            reset(data);
        }
    }, [data, reset]);

    

    return (
        <>
            <FormProvider {...methods}>
                <Box
                    component='form'
                    
                    noValidate
                >

                    <ShipmentHistoryUpdateForm watch={watch}/>

                    <Stack direction="row" justifyContent="end" spacing={1} padding={5}>

                        { cancelButton }

                        
                    </Stack>
                </Box>
            </FormProvider>
        </>
    )
}

export default ShipmentHistoryUpdateFormProvider
